// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"ToggleSwitch_toggleSwitch__sqJyR","disabled":"ToggleSwitch_disabled__P6POp","option":"ToggleSwitch_option__AQNak","selected":"ToggleSwitch_selected__Q-bLp"};